import * as React from 'react';
import {Button, Checkbox, Form, Icon, Input} from 'antd';
import {FormComponentProps} from 'antd/lib/form';
import ButtonBar from '../common/ButtonBar';
import locales from '../locales';
import FormItem from 'antd/lib/form/FormItem';
import * as formUtils from '../utils/form-utils';
import {isNotBlank} from '../utils/string-utils';
import {MaintenanceTodoEntry, MaintenanceTodos} from '../api/dtos/dtos';
import {CheckboxChangeEvent} from "antd/lib/checkbox";
import './MaintenanceTodoForm.css';

interface Props extends FormComponentProps {
  entries: MaintenanceTodoEntry[];
  onFormSubmit: (todos: MaintenanceTodos) => void;
  onFormCancel: () => void;
}

interface State {
  entries: MaintenanceTodoEntry[];
}

const emptyEntry = (): MaintenanceTodoEntry => ({
  checked: false,
  comment: '',
});

class MaintenanceTodoForm extends React.Component<Props, State> {

  public state: State = {
    entries: this.props.entries && this.props.entries.length > 0 ? this.props.entries : [emptyEntry()],
  };

  public render(): React.ReactNode {
    const {entries} = this.state;
    return (
      <Form>
        <ButtonBar style={{marginBottom: 8}}>
          <Button size="small" type="primary" icon="plus" onClick={this.onAddButtonClick}>
            {locales.add}
          </Button>
        </ButtonBar>

        <div className="maintenance-todo-form">
          {entries.map(this.renderRow)}
        </div>

        {this.props.children}

        <FormItem {...formUtils.tailFormItemLayout}>
          <Button type="primary" onClick={this.onFormSubmit}>
            {locales.save}
          </Button>
          <Button style={{marginLeft: 8}} onClick={this.props.onFormCancel}>
            {locales.cancel}
          </Button>
        </FormItem>
      </Form>
    );
  }

  private renderRow = (entry: MaintenanceTodoEntry, idx: number): React.ReactNode => {
    const comment = entry.comment ? entry.comment : '';

    const addonBefore: React.ReactNode = (
      <div style={{lineHeight: '21px'}}>
        <Checkbox checked={entry.checked} onChange={this.onCheckBoxChange(idx)}/>
      </div>
    );

    const addonAfter: React.ReactNode = (
      <a onClick={this.onDeleteButtonClick(idx)} title={locales.delete}>
        <Icon type="delete"/>
      </a>
    );

    const inputClassName = entry.checked ? 'checked' : undefined;

    return (
      <Input
        key={`row-${idx}`}
        className={inputClassName}
        style={{marginBottom: 16}}
        addonBefore={addonBefore}
        addonAfter={addonAfter}
        placeholder={locales.comment}
        value={comment}
        onChange={this.onValueChange(idx)}
      />
    );
  };

  private onCheckBoxChange = (idx: number) => (evt: CheckboxChangeEvent) => {
    this.replaceEntryAt(idx, {
      checked: evt.target.checked,
      comment: this.state.entries[idx].comment,
    });
  };

  private onValueChange = (idx: number) => (evt: React.ChangeEvent<HTMLInputElement>) => {
    this.replaceEntryAt(idx, {
      checked: this.state.entries[idx].checked,
      comment: evt.target.value,
    });
  };

  private replaceEntryAt(idx: number, entry: MaintenanceTodoEntry) {
    const entries = [...this.state.entries];
    entries.splice(idx, 1, entry);
    this.setState({entries,});
  }

  private onDeleteButtonClick = (idx: number) => () => {
    const entries = [...this.state.entries];
    entries.splice(idx, 1);

    if (entries.length === 0) {
      entries.push(emptyEntry());
    }

    this.setState({entries,});
  };

  private onAddButtonClick = () => {
    const {entries} = this.state;
    this.setState({
      entries: [emptyEntry(), ...entries],
    });
  };

  private onFormSubmit = () => {
    this.props.onFormSubmit({
      entries: this.state.entries.filter(entry => isNotBlank(entry.comment))
    });
  };
}

export default Form.create<Props>()(MaintenanceTodoForm);


// WEBPACK FOOTER //
// ./src/item-details/MaintenanceTodoForm.tsx